/* Bootstrap  */
//import "bootstrap";
import { Modal, Tooltip } from 'bootstrap'
/* Custom SCSS */
import "./index.scss";


/* SwiperJS */
import Swiper from 'swiper';
import 'swiper/css';


$(document).ready( function() { 

    $('.btn-tooltip').each(function() {
        new Tooltip($(this))
    })

    if($('.swiper_links').length) {
        var swiper = new Swiper(".swiper_links", {
            slidesPerView: "auto",
            spaceBetween: 30
        });
    }

    if($('.homepage').length) {
        var left_panel = $('#left_panel>.row').height()
        $('#right_panel .box_wrapper').css( 'max-height',left_panel-24)
    }

    $('.navbar-toggler').click(function() {
        $(this).toggleClass('collapsed');
        $('.sidebar').toggleClass('aperto');
        $('body').toggleClass('noscroll');
    });
    
    var delay=300
    var timer;
    $('.mitre_attack .colonne .colonna .valori>div, .infobox_wrapper').hover( function() {
        var element = $(this)
        timer = setTimeout(function() {
            element.find('.infobox').fadeIn()
            console.log('ciao')
        }, delay, element);
    }, function() {
        clearTimeout(timer);
        $(this).find('.infobox').fadeOut()
    })




})